import { ImageEdit, QuillEditor } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { TOOLBAR_CONFIG_TYPES } from "@pathwright/ui/src/components/quill/toolbar/QuillToolbar"
import { BackgroundWrapper, Title, TitleDivider, TitleWrapper } from "./ui"

const placeholderImage = "https://cdn.filestackcontent.com/fEaAvEy8RKqiJTH2Lg7j"

const TitleEdit = (props) => {
  const { layout, data, onChange, blockStyles } = props

  if (layout === "title") {
    return (
      <Content.Container>
        <TitleWrapper>
          <Title>
            <QuillEditor
              toolbar={TOOLBAR_CONFIG_TYPES.SIMPLE}
              html={data.title}
              onChange={(title) => onChange({ ...data, title })}
              contentType={null}
              controlled
              autoListFormatting={false}
            />
          </Title>
          <TitleDivider />
        </TitleWrapper>
      </Content.Container>
    )
  }

  if (layout === "titleImage") {
    return (
      <BackgroundWrapper>
        <ImageEdit
          image={data.image || placeholderImage}
          altText={data.altText}
          overlay="rgba(0,0,0,0.3)"
          onChangeImage={(image) => onChange({ image })}
          backgroundMode={true}
          blockStyles={blockStyles}
        />
        <Content.Container>
          <TitleWrapper>
            <Title headingColor="white">
              <QuillEditor
                toolbar={TOOLBAR_CONFIG_TYPES.BASIC}
                html={data.title}
                onChange={(title) => onChange({ title })}
                controlled
              />
            </Title>
          </TitleWrapper>
        </Content.Container>
      </BackgroundWrapper>
    )
  }

  return null
}

export default TitleEdit
